import { arrayMove } from "@dnd-kit/sortable"

export interface NewsImageTileState {
	/** set as soon as the upload has finished */
	id?: string
	/** identifies the tile while it has no id yet, so a finished upload does not remount its tile */
	key: string
	previewUrl?: string
	/** the share of the image that has been sent in whole percents, only while it is uploading */
	progress?: number
	status: "done" | "uploading"
}

export const toImageIds = (tiles: NewsImageTileState[]): string[] =>
	tiles.flatMap(({ id, status }) => (status === "done" && id ? [id] : []))

export const reorderTiles = (
	tiles: NewsImageTileState[],
	activeKey: string,
	overKey: string | undefined,
): NewsImageTileState[] => {
	const from = tiles.findIndex(({ key }) => key === activeKey)
	const to = tiles.findIndex(({ key }) => key === overKey)
	return from < 0 || to < 0 || from === to ? tiles : arrayMove(tiles, from, to)
}
